<template>
  <section class="trending-queries">
    <h6 class="margin-bottom-s">Popular searches</h6>

    <div v-if="isLoading" class="trending-queries-loading">
      <div class="nav-scroller">
        <div class="nav-scroller-content gap-16">
          <Skeleton v-for="n in 8" :key="n" height="28px" width="100px" />
        </div>
      </div>
    </div>

    <Scroller v-else ref="scrollerRef">
      <ul class="nav-scroller-content gap-16">
        <li v-for="item in trendingData" :key="item" @click="addToSearchHistory(item)">
          <Link class="undecorated-link" :href="buildSearchUrl(item)">
            <i class="search-dark-small"></i>
            <span class="medium">{{ item }}</span>
          </Link>
        </li>
      </ul>
    </Scroller>
  </section>
</template>

<script setup>
import { computed, onMounted, ref, nextTick } from 'vue';
import Link from '../common/Link';
import { useNavTrendingQueries } from '~/stores/navTrendingQueries';
import { FETCH_TRENDING_QUERIES } from '#shared/types/actions';
import Skeleton from '@atomic-ui/skeleton/Skeleton';
import useSearchUrl from '~/composables/ui/useSearchUrl';
import useExperimentsArms from '~/composables/useExperimentsArms';
import useSearchHistory from '~/composables/dumb/useSearchHistory';
import Scroller from '~/components/common/Scroller.common';

const navTrendingQueries = useNavTrendingQueries();
const { buildSearchUrl } = useSearchUrl();
const experimentsArms = useExperimentsArms();
const { addToSearchHistory } = useSearchHistory();

const trendingData = computed(() => navTrendingQueries.trendingData);
const isLoading = computed(() => navTrendingQueries.isLoadingTrending);

const scrollerRef = ref(null);

onMounted(async () => {
  if (!trendingData.value.length) {
    const armNumber = experimentsArms.value.popularSearchesArm2 ? 2 : 1;
    await navTrendingQueries[FETCH_TRENDING_QUERIES](armNumber);
  }
  await nextTick();
  scrollerRef.value?.updateArrows();
});
</script>

<style lang="scss">
@import '~/assets/scss/mixins/index.scss';

.gap-16 {
  gap: 16px;
}

.trending-queries {
  a {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 28px;
    padding: 0 12px;
    gap: 8px;
    white-space: nowrap;
  }
}
</style>

<style lang="scss" brand="mcom">
@import '~/assets/scss/mixins.mcom.scss';

.trending-queries {
  a {
    border-radius: 14px;
    border: 1px solid $gray-2-color;
  }
}
</style>

<style lang="scss" brand="bcom">
@import '~/assets/scss/mixins.bcom.scss';

.trending-queries {
  a {
    border: 1px solid $black;
  }
}
</style>
